import React from 'react';
import PropTypes from 'prop-types';

import RouteBundler from 'components/RouteBundler';
import AuthorizationWrapper from 'components/Auth/AuthorizationWrapper';
import roles from 'core/roles';

import ViewNotifications from './ViewNotifications';
import UpdateNotification from './UpdateNotification';
import CreateNotification from './CreateNotification';

const routes = [
  { path: '', component: ViewNotifications, exact: true },
  { path: ':id/edit', component: UpdateNotification, exact: true },
  { path: 'new', component: CreateNotification, exact: true },
];

class Notifications extends React.Component {
  static propTypes = {
    me: PropTypes.shape({
      id: PropTypes.string.isRequired,
    }).isRequired,
    match: PropTypes.shape({
      path: PropTypes.string.isRequired,
    }).isRequired,
  };

  render() {
    return (
      <RouteBundler
        prefix={`${this.props.match.path}/`}
        routes={routes}
        me={this.props.me}
      />
    );
  }
}

export default AuthorizationWrapper([roles.ADMIN])(Notifications);
